var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkEmpty = function SvgBookmarkEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M22.44 5.72c4.62 0 5.16 2.36 5.16 4.13v20.32l-.04.04h-.06l-8.46-4.78-.98-.55-.98.55-8.58 4.8s-.03 0-.05-.02-.02-.03-.02-.06V9.59c0-2.57 1.74-3.87 5.16-3.87h8.88m0-2h-8.88c-4.55 0-7.16 2.14-7.16 5.87v20.55a2.065 2.065 0 0 0 2.07 2.08c.36 0 .71-.09 1.02-.27l8.55-4.79 8.46 4.78a2.05 2.05 0 0 0 1.58.19c.53-.15.98-.5 1.25-.98.18-.31.27-.66.27-1.02V9.85c0-3.95-2.55-6.13-7.16-6.13"
  })));
};
export default SvgBookmarkEmpty;